module.exports = __webpack_public_path__ + "static/media/product-services1.f75ec950.jpg";